import { TAB_INVOICE, TAB_PATIENT, TAB_PAYMENTS } from 'services/constants';
// Constants
import { ROLES } from 'services/constants';

import * as styles from './styles';

const allTabs = [
  {
    id: 'appointment-tab-1',
    type: TAB_PATIENT,
    translateKey: 'patient_tab',
  },
  {
    id: 'appointment-tab-2',
    type: TAB_INVOICE,
    translateKey: 'invoice_tab',
  },
  {
    id: 'appointment-tab-3',
    type: TAB_PAYMENTS,
    translateKey: 'payments_tab',
  },
  //──── features ──────────────────────────────────────────────────────────────────────────
  // {
  //   id: 'appointment-tab-4',
  //   type: null,
  //   translateKey: 'appointment_tab',
  // },
  // {
  //   id: 'appointment-tab-5',
  //   type: null,
  //   translateKey: 'messages_tab',
  // },
  // {
  //   id: 'appointment-tab-6',
  //   type: null,
  //   translateKey: 'events_tab',
  // }
];

const tabsByRole = (role) =>{
  if (role === ROLES.RADIOLOGY) {
    const tempArr = allTabs.map(el => el);
    tempArr.splice(1,2); // remove invoice & payment tab
    return tempArr;
  }
  return allTabs;
};

export default ({ i18n, changeTab, activeTab, role }) => {
  const tabs = tabsByRole(role);
  return (
    <styles.NavigationWrapper>
      {tabs.map(tab => (
        <li key={tab.id}>
          <styles.Item isActive={activeTab === tab.type} onClick={() => changeTab(tab.type)}>
            {i18n.t(tab.translateKey)}
          </styles.Item>
        </li>)
      )}
    </styles.NavigationWrapper>
  );
};
